// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import ContentBox from '../../../ContentBox.jsx';
import { PrimaryText } from '../../../Typography.jsx';
import { Button } from '../../../Buttons.jsx';

import ViewVitals from './ViewVitals.jsx';
import ViewPhysicalExamination from './ViewPhysicalExamination.jsx';
import ViewDevelopment from './ViewDevelopment.jsx';

import getVitalsThresholds from '../../vitals/getThresholds';

import styles from '../../../../styles/patientPages/wellChildCheck/Form.scss';

type Props = {
  match: { params: { id: string, type: number }},
  history: { goBack: Function },
  wellChildChecks: Object[],
  dob: string,
}

type State = {
  wellChildCheck: Object,
}

class ViewFormPageComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      wellChildCheck: this.props.wellChildChecks.find(
        wcc => wcc._id === this.props.match.params.id,
      ) || {},
    };
  }

  render() {
    const {
      physicalExamination,
      developmentMilestones,
      developmentNormal,
      developmentNotes,
      developmentGrade,
      date,
      notes,
      editors,
      editDates,
      overridden,
      age,
    } = this.state.wellChildCheck;
    let { vitals } = this.state.wellChildCheck;
    vitals = {
      ...vitals,
      ...getVitalsThresholds(this.props.dob, date),
    };

    let { type } = this.props.match.params;
    type = parseInt(type, 10);

    let editHistory = '';
    for (let i = 0; i < editors.length; i++) {
      if (i === editors.length - 1) {
        editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]} (created) \n`;
      } else {
        editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]}\n`;
      }
    }

    return (
      <ContentBox title={`${age} Well Child Check${overridden ? ' (overridden)' : ''}`}>
        {/* TODO: Print WCCs */}
        {/* <span className={styles.hidden}><Button onClick={window.print}>Print</Button></span> */}
        <div className={styles.topRow}>
          <div className={styles.vitals}>
            <ViewVitals
              vitals={vitals}
              type={type}
            />
          </div>
          <div className={styles.development}>
            <ViewDevelopment
              developmentMilestones={developmentMilestones}
              developmentNormal={developmentNormal}
              developmentNotes={developmentNotes}
              developmentGrade={developmentGrade}
              type={type}
            />
          </div>
        </div>
        <div className={styles.physicalExam}>
          <ViewPhysicalExamination
            physicalExamination={physicalExamination}
          />
        </div>
        <div className={styles.notes}>
          <PrimaryText>Notes</PrimaryText>
          <div>{notes || '--'}</div>
        </div>
        <table className={styles.examDateTable}>
          <tbody>
            <tr>
              <td><PrimaryText>Exam Date: </PrimaryText></td>
              <td>{date ? moment(date).format() : '--'}</td>
            </tr>
            <tr className={styles.editHistoryRow}>
              <td><strong>Edit History: </strong></td>
              <td>{editHistory || '--'}</td>
            </tr>
          </tbody>
        </table>
        <span className={styles.hidden}><Button onClick={this.props.history.goBack}>Back</Button></span>
      </ContentBox>
    );
  }
}

const mapStateToProps = state => ({
  wellChildChecks: state.patient.data.wellChildChecks,
  dob: state.patient.data.generalInfo.dob,
});

const ViewFormPage = connect(
  mapStateToProps,
)(ViewFormPageComponent);

export default ViewFormPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/wellChildCheck/view/ViewFormPage.jsx